import { OfficeConsentAdapter } from '../adapters';
import { ConsentsClient } from '../clients';
import { OfficeConsentNotFoundError } from '../errors';
import type { IOfficeConsent } from '../types/OfficeConsent';
import type { IGetOfficeConsentParameters } from '../types/OfficeConsent.parameters';

export const getOfficeConsent = async (
  params: IGetOfficeConsentParameters,
): Promise<IOfficeConsent> => {
  try {
    const apiResponse = await ConsentsClient.getOfficeConsent(params);

    // Transform API response to Domain type
    return OfficeConsentAdapter.toOfficeConsent(apiResponse);
  } catch (e) {
    const officeConsentNotFound = OfficeConsentNotFoundError.fromAxiosError(e);
    if (officeConsentNotFound) {
      throw officeConsentNotFound;
    }

    throw e;
  }
};
